import React from "react";
import { Sidebar } from "react-admin";

const IvcAdminSidebar = props => <Sidebar {...props} size={150} />;

export default IvcAdminSidebar;
